import React, { useState } from 'react';
import { Button } from './ui/button';
import { Shield, Award, Heart, CheckCircle2, ArrowRight } from 'lucide-react';
import PartnershipModal from './PartnershipModal';
import TransportationInterestModal from './TransportationInterestModal';

const HeroSection = () => {
  const [showPartnershipModal, setShowPartnershipModal] = useState(false);
  const [showTransportModal, setShowTransportModal] = useState(false);

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_trusted-journeys-co/artifacts/9nwkoeie_classic-bus-sales-sprinter-mcsweeney-ext-ds-fb-1-1-1484719635_1024x1024%402x.webp" 
          alt="NO LIMIT 365 Mercedes Sprinter passenger van"
          className="w-full h-full object-cover"
        />
        {/* Beachy Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0077BE]/90 via-[#00B4D8]/80 to-[#023E8A]/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20 text-center">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
            Transportation That<br />Supports the Whole Child
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4">
            Safe, reliable 10-passenger vans providing specialized transportation for students with unique needs.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-12 sm:mb-16 px-4">
          <Button 
            size="lg"
            onClick={() => setShowTransportModal(true)}
            className="bg-white text-[#0077BE] hover:bg-white/90 text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 rounded-2xl font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 flex items-center gap-2 justify-center w-full sm:w-auto"
          >
            Get Transportation
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </Button>
          <Button 
            size="lg"
            onClick={() => setShowPartnershipModal(true)}
            variant="outline"
            className="bg-transparent border-2 border-white text-white hover:bg-white/10 text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 rounded-2xl font-semibold backdrop-blur-sm transition-all duration-300 hover:scale-105 w-full sm:w-auto"
          >
            District Partnership
          </Button>
        </div>

        {/* Glass Cards - Trust Indicators */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 max-w-5xl mx-auto px-4">
          <div className="glass-card p-4 sm:p-6 rounded-2xl backdrop-blur-md bg-white/15 border border-white/20 hover:bg-white/25 transition-all duration-300 hover:scale-105">
            <Shield className="w-8 h-8 sm:w-10 sm:h-10 text-white mx-auto mb-2 sm:mb-3" />
            <p className="text-white font-semibold text-xs sm:text-sm">Safety First</p>
          </div>
          <div className="glass-card p-4 sm:p-6 rounded-2xl backdrop-blur-md bg-white/15 border border-white/20 hover:bg-white/25 transition-all duration-300 hover:scale-105">
            <Award className="w-8 h-8 sm:w-10 sm:h-10 text-white mx-auto mb-2 sm:mb-3" />
            <p className="text-white font-semibold text-xs sm:text-sm">20+ Years Experience</p>
          </div>
          <div className="glass-card p-4 sm:p-6 rounded-2xl backdrop-blur-md bg-white/15 border border-white/20 hover:bg-white/25 transition-all duration-300 hover:scale-105">
            <Heart className="w-8 h-8 sm:w-10 sm:h-10 text-white mx-auto mb-2 sm:mb-3" />
            <p className="text-white font-semibold text-xs sm:text-sm">Trauma-Informed Approach</p>
          </div>
          <div className="glass-card p-4 sm:p-6 rounded-2xl backdrop-blur-md bg-white/15 border border-white/20 hover:bg-white/25 transition-all duration-300 hover:scale-105">
            <CheckCircle2 className="w-8 h-8 sm:w-10 sm:h-10 text-white mx-auto mb-2 sm:mb-3" />
            <p className="text-white font-semibold text-xs sm:text-sm">100% Compliant</p>
          </div>
        </div>
      </div>

      {/* Animated Light Effect */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
      
      {/* Modals */}
      <PartnershipModal 
        open={showPartnershipModal} 
        onOpenChange={setShowPartnershipModal}
      />
      <TransportationInterestModal 
        open={showTransportModal} 
        onOpenChange={setShowTransportModal}
      />
    </section>
  );
};


export default HeroSection;